import { AMOUNTS } from 'constants/amounts';

import type { TRankingProductRequest } from 'shared/types/TRankingService';

import { selectCreditPurposeInfoData } from 'entities/creditForm';

export const collectProductRequestPayloadThunk =
  (): ThunkResult<Pick<TRankingProductRequest, 'amount' | 'term'>> => (_, getState) => {
    const state = getState();
    const formData = selectCreditPurposeInfoData(state);
    const normalizedAmount = Number(formData.amount);

    return {
      amount: normalizedAmount >= 0 ? normalizedAmount : AMOUNTS.defaultFormValue,
      term: formData.period?.value || 'P3Y',
    };
  };
